//
//
//
//
//
//
//

export default {
    props: {
        checked: {
            default: false
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/common/checkBox.vue